import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import ptBR from './locales/pt-BR.json';
import fr from './locales/fr.json';

// Locale codes match backend `settings.language` values from
// /api/settings/language (en / es / pt-BR / fr).
export const SUPPORTED_LOCALES = ['en', 'es', 'pt-BR', 'fr'];
export const DEFAULT_LOCALE = 'en';
const CACHE_KEY = 'mtk_lang';

// Read a cached locale so signed-out visitors and the /auth screen still
// see the language a user last selected. Falls back to DEFAULT_LOCALE.
function initialLocale() {
  try {
    const v = localStorage.getItem(CACHE_KEY);
    if (v && SUPPORTED_LOCALES.includes(v)) return v;
  } catch { /* ignore */ }
  return DEFAULT_LOCALE;
}

// Persist current locale so it survives logout / hard reloads.
export function persistLocale(code) {
  if (!SUPPORTED_LOCALES.includes(code)) return;
  try { localStorage.setItem(CACHE_KEY, code); } catch { /* ignore */ }
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      'pt-BR': { translation: ptBR },
      fr: { translation: fr },
    },
    lng: initialLocale(),
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false }, // React already escapes.
    returnEmptyString: false,
  });

// Keep the cache in sync when i18n.changeLanguage() is called from anywhere.
i18n.on('languageChanged', (lng) => persistLocale(lng));

export default i18n;
